import {BUSINESS_NAME} from "@/content";

export type ParallaxContent = {
    title: string;
    subTitle: string;
    overline: string;
    imageUrl: string;
    buttonCTA: string;
    buttonLink: string;
};

export const parallaxContent1: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Level 2 Electricians in Sydney',
    subTitle:'Reliable and Accredited Level 2 Electrical Services in Sydney',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-1.jpg',
    buttonCTA:'Level 2 Electricians Near Me',
    buttonLink:undefined, //define this in the page
}

export const parallaxContent2: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Commercial Electrical Services',
    subTitle:'Commercial Electrical Services for Businesses in Sydney',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-2.jpg',
    buttonCTA:'Commercial Electrician in Sydney',
    buttonLink:undefined, //define this in the page
}
